import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  FloatingLabel,
  Card,
} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AuthService } from "../../services/AuthService.js";
import LoadingModal from "../components/LoadingModal";
import login from "../../style/images/login.jpg";
import { FaUser, FaHospital, FaEye, FaEyeSlash } from "react-icons/fa";
import "./Login.css";

const LoginPage = () => {
  const navigate = useNavigate();
  const [session, setSession] = useSearchParams();
  const [user, setUser] = useState({
    email: "",
    password: "",
  });
  const [error, setError] = useState({
    email: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false); 
  const [loading, setLoading] = useState(false);
  const [loginType, setLoginType] = useState('user'); // 'user' or 'hospital'
  const isValid = () => {
    let temp = { email: "", password: "" };
    let flag = true;
    if (
      !user.email ||
      !user.email.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)
    ) {
      temp.email = "Required or Invalid Email";
      flag = false;
    }
    if (!user.password) {
      temp.password = "Required";
      flag = false;
    }
    setError(temp);
    return flag;
  };
  const onLogin = async () => {
    if (isValid()) {
      setLoading(true);
      try {
        let res;
        if (loginType === 'hospital') {
          res = await AuthService.hospitalLogin(user.email, user.password);
        } else {
          res = await AuthService.login(user.email, user.password);
        }
        
        if (res.status === 200) {
          navigate("/dashboard");
        } else {
          alert("Wrong username or password");
        }
        setLoading(false);
      } catch (error) {
        alert(error.message || "An error occurred during login");
        setLoading(false);
      }
    }
  };
  useEffect(() => {
    if (AuthService.isLoggedin()) {
      navigate("/dashboard");
    }
  }, []);
  return (
    <Container fluid className="bg-light min-vh-100 p-0">
      <Row className="g-0 min-vh-100">
        {/* Left Side - Image */}
        <Col md={7} className="d-flex p-0">
          <div className="position-relative w-100">
            <img
              src={login}
              alt="Login Visual"
              className="img-fluid w-100 h-100"
              style={{
                objectFit: 'cover',
                objectPosition: 'center',
                height: '100%',
                position: 'absolute',
                top: 0,
                left: 0
              }}
            />
            <div 
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.1)'
              }}
            ></div>
          </div>
        </Col>

        {/* Right Side - Login Form */}
        <Col md={5} className="d-flex align-items-center justify-content-center p-4" style={{ minHeight: '100vh' }}>
          <div 
            className="bg-white p-4 p-md-5 rounded-3 shadow-sm w-100"
            style={{
              maxWidth: '500px',
              border: '1px solid rgba(0, 0, 0, 0.1)'
            }}
          >
            <div className="text-center mb-4">
              <h2 
                className="fw-bold mb-3"
                style={{
                  color: '#2c3e50',
                  fontSize: '2rem',
                  letterSpacing: '0.5px',
                  position: 'relative',
                  display: 'inline-block',
                  paddingBottom: '0.5rem'
                }}
              >
                Login
                <span 
                  style={{
                    content: '""',
                    position: 'absolute',
                    bottom: '0',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    width: '60px',
                    height: '3px',
                    backgroundColor: '#0d6efd',
                    borderRadius: '2px'
                  }}
                ></span>
              </h2>
            </div>
            
            {/* Login Type Selection */}
            <div className="d-flex justify-content-center mb-4">
              <div 
                className={`d-flex flex-column align-items-center p-3 mx-2 border rounded-3 cursor-pointer ${loginType === 'user' ? 'border-primary shadow-sm' : 'border-light shadow-sm'}`}
                style={{
                  width: '120px',
                  transition: 'all 0.3s ease-in-out',
                  backgroundColor: loginType === 'user' ? '#f8f9fa' : 'white',
                  boxShadow: loginType === 'user' 
                    ? '0 0.125rem 0.25rem rgba(13, 110, 253, 0.3)' 
                    : '0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)'
                }}
                onClick={() => setLoginType('user')}
              >
                <FaUser size={24} className="mb-2" style={{ color: loginType === 'user' ? '#0d6efd' : '#6c757d' }} />
                <span className={loginType === 'user' ? 'text-primary fw-bold' : 'text-muted'} style={{ textAlign: 'center' }}>Admin Login</span>
              </div>
              <div 
                className={`d-flex flex-column align-items-center p-3 mx-2 border rounded-3 cursor-pointer text-center ${loginType === 'hospital' ? 'border-primary shadow-sm' : 'border-light shadow-sm'}`}
                style={{
                  width: '120px',
                  transition: 'all 0.3s ease-in-out',
                  backgroundColor: loginType === 'hospital' ? '#f8f9fa' : 'white',
                  boxShadow: loginType === 'hospital' 
                    ? '0 0.125rem 0.25rem rgba(13, 110, 253, 0.3)' 
                    : '0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)'
                }}
                onClick={() => setLoginType('hospital')}
              >
                <FaHospital size={24} className="mb-2" style={{ color: loginType === 'hospital' ? '#0d6efd' : '#6c757d' }} />
                <span className={`${loginType === 'hospital' ? 'text-primary fw-bold' : 'text-muted'} w-100`} style={{ textAlign: 'center' }}>Hospital Login</span>
              </div>
            </div>

            <Form>
              <FloatingLabel label="Email" className="my-3">
                <Form.Control
                  name="email"
                  value={user.email}
                  onChange={(e) => setUser({ ...user, email: e.target.value })}
                  type="email"
                  isInvalid={!!error.email}
                  placeholder="Email"
                />
                {error.email && (
                  <p className="required-field-meassage">{error.email}</p>
                )}
              </FloatingLabel>
              <FloatingLabel label="Password" className="my-3 position-relative">
  <Form.Control
    name="password"
    placeholder="Password"
    value={user.password}
    onChange={(e) => setUser({ ...user, password: e.target.value })}
    onKeyDown={(e) => {
      if (e.code === "Enter") onLogin();
    }}
    type={showPassword ? "text" : "password"} 
    isInvalid={!!error.password}
  />
  <span
    onClick={() => setShowPassword(!showPassword)}
    style={{
      position: "absolute",
      right: "15px",
      top: "50%",
      transform: "translateY(-50%)",
      cursor: "pointer",
      color: "#6c757d"
    }}
  >
    {showPassword ? <FaEyeSlash style={{ color: '#05275a' }} /> : <FaEye style={{ color: '#05275a' }} />}
  </span>
  {error.password && (
    <p className="required-field-meassage">{error.password}</p>
  )}
</FloatingLabel>

              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '8px', marginBottom: '18px' }}>
              <Button
                  className="custom-btn"
                  type="button"
                  onClick={onLogin}
                  disabled={loading}
                  style={{ margin: 0 }}
                >Login
                </Button>
                <Link to="/forgotPassword" style={{ textDecoration: 'none', color: '#0d6efd', fontWeight: 500 }}>
                  Forgot Password?
                </Link>
                
              </div>
            </Form>
            {session.get("session") && (
              <Card className="mt-3">
                <Card.Body className="session-expired text-center p-2">
                  Your session has expired. Please log in again to continue.
                </Card.Body>
              </Card>
            )}
            <LoadingModal show={loading} />
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default LoginPage;
